import React, { useState } from 'react';
import { Container, Card, Form, Button, Row, Col, Stack } from 'react-bootstrap';
import api from '../api/api';
import { showToast } from '../utils/toast';

const RegistrationPage = () => {
  const [formData, setFormData] = useState({
    institution_name: '', 
    admin_name: '', 
    academic_title: '',
    email: '', 
    contact_number: '', 
    country_code: '+91', 
    accept_terms: false
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/public/register-tenant', formData);
      window.location.href = '/registration-thank-you';
    } catch (err) {
      showToast(err.response?.data?.detail || "Registration failed. Please try again.", 'error');
    }
  };

  return (
    <div className="bg-light min-vh-100 d-flex align-items-center py-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            {/* 1. Branding Section (Mirroring Login Page)  */}
            <div className="text-center mb-4">
              <img 
                src="/assets/images/logo.png" 
                alt="AcademicOS Logo" 
                style={{ height: '60px', marginBottom: '15px' }} 
              />
              <h2 className="fw-bold text-dark">AcademicOS</h2>
              <p className="text-muted">Embracing Academic Intelligence</p>
            </div>

            <Card className="shadow-lg border-0">
              <Card.Body className="p-4 p-md-5">
                <div className="mb-4">
                  <h4 className="fw-bold text-primary">Institutional Registration</h4>
                  <p className="text-muted small">
                    Register to activate AcademicOS for your institution.
                  </p>
                </div>

                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={12} className="mb-3">
                      <Form.Label className="small fw-bold">Institution Name</Form.Label>
                      <Form.Control 
                        required 
                        placeholder="e.g., Texila American University"
                        onChange={e => setFormData({...formData, institution_name: e.target.value})} 
                      />
                    </Col>
                    
                    <Col md={6} className="mb-3">
                      <Form.Label className="small fw-bold">Administrator Name</Form.Label>
                      <Form.Control 
                        required 
                        placeholder="Full Name"
                        onChange={e => setFormData({...formData, admin_name: e.target.value})} 
                      />
                    </Col>
                    
                    <Col md={6} className="mb-3">
                      <Form.Label className="small fw-bold">Academic Title</Form.Label>
                      <Form.Control 
                        required 
                        placeholder="e.g., Dean, HOD, Director"
                        onChange={e => setFormData({...formData, academic_title: e.target.value})} 
                      />
                    </Col>

                    <Col md={4} className="mb-3">
                      <Form.Label className="small fw-bold">Country Code</Form.Label>
                      <Form.Control 
                        required 
                        placeholder="+91"
                        value={formData.country_code}
                        onChange={e => setFormData({...formData, country_code: e.target.value})} 
                      />
                    </Col>

                    <Col md={8} className="mb-3">
                      <Form.Label className="small fw-bold">Contact Number</Form.Label>
                      <Form.Control 
                        required 
                        placeholder="9876543210"
                        onChange={e => setFormData({...formData, contact_number: e.target.value})} 
                      />
                    </Col>
                    
                    <Col md={12} className="mb-3">
                      <Form.Label className="small fw-bold">Official Work Email</Form.Label>
                      <Form.Control 
                        type="email" 
                        required 
                        placeholder="admin@institution.edu"
                        onChange={e => setFormData({...formData, email: e.target.value})} 
                      />
                    </Col>
                  </Row>

                  {/* 2. Enhanced Compliance Section  */}
                  <Form.Group className="mb-4 bg-light p-3 rounded border">
                    <Form.Check 
                      type="checkbox" 
                      id="terms-checkbox"
                      required 
                      onChange={e => setFormData({...formData, accept_terms: e.target.checked})}
                      label={
                        <span className="small">
                          I agree to the <a href="/terms" target="_blank" className="text-decoration-none fw-bold">Terms of Use</a> and acknowledge the <a href="/privacy" target="_blank" className="text-decoration-none fw-bold">Privacy Policy</a>.
                        </span>
                      }
                    />
                  </Form.Group>

                  <Button type="submit" variant="primary" className="w-100 fw-bold py-2 shadow-sm">
                    Verify Email & Activate Credits
                  </Button>
                </Form>
              </Card.Body>
              
              <Card.Footer className="bg-white border-0 text-center pb-4">
                <span className="text-muted small">Already have an institutional account? </span>
                <a href="/login" className="text-primary fw-bold text-decoration-none small">Sign In</a>
              </Card.Footer>
            </Card>

            {/* 3. Footer Links */}
            <Stack direction="horizontal" gap={3} className="justify-content-center mt-4">
              <a href="/privacy" className="text-muted small text-decoration-none">Privacy Policy</a>
              <div className="vr" style={{ height: '15px', marginTop: '5px' }}></div>
              <a href="/terms" className="text-muted small text-decoration-none">Terms of Service</a>
              <div className="vr" style={{ height: '15px', marginTop: '5px' }}></div>
              <a href="/contact" className="text-muted small text-decoration-none">Support</a>
              <div className="vr" style={{ height: '15px', marginTop: '5px' }}></div>
              <a href="/release-notes" className="text-muted small text-decoration-none">What's New</a>
            </Stack>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default RegistrationPage;
